/* eslint-disable react/button-has-type */

import { PlusOutlined } from '@ant-design/icons';
import React, { useCallback, useEffect, useState } from 'react';
import styled from 'styled-components';
import { COLORS } from '../../../../style/color';
import { useScheduledFeatureContext } from '../ScheduledFeatureContext';
import { ShopRow } from './ShopRow';
import Checkbox from './Checkbox';

const BlankColumn = styled.td`
    width: 16px;
`;

const ShopTableContainer = styled.div`
    display: block;
    overflow-y: scroll;
    max-height: 400px;
`;

const TableHeader = styled.thead`
    position: sticky;
    top: 0;
`;

const ButtonContainerRight = styled.div`
    display: flex;
    justify-content: end;
    margin-right: 16px;
`;

const ActionButton = styled.button`
    cursor: pointer;
    padding: 10px;
    border: 1px solid #000;
    border-radius: 5px;
    width: 150px;
    text-align: center;
    margin-bottom: 10px;

    display: flex;
    justify-content: center;
    gap: 8px;
`;

const IconContainer = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100%;
`;

const StyledThTitle = styled.th`
    padding: 10px;
    text-align: center;
    background: ${COLORS.stuartBlue};
    color: ${COLORS.white};
`;

export const ShopTable = ({ isEditable }: { isEditable: boolean }) => {
    const { shops, enableAllShops, disableAllShops, handleAddShop } = useScheduledFeatureContext();

    const [isAllShopsEnabled, setIsAllShopsEnabled] = useState(false);

    useEffect(() => {
        const allShopsEnabled = shops.length > 0 && shops.every((shop) => shop.enabled);
        setIsAllShopsEnabled(allShopsEnabled);
    }, [shops]);

    const handleToggleAllShops = useCallback(() => {
        if (isAllShopsEnabled) {
            disableAllShops();
            return;
        }

        enableAllShops();
    }, [shops, isAllShopsEnabled]);

    return (
        <>
            {isEditable && (
                <ButtonContainerRight>
                    <ActionButton onClick={handleAddShop}>
                        <IconContainer>
                            <PlusOutlined />
                        </IconContainer>
                        <div> Add Shop</div>
                    </ActionButton>
                </ButtonContainerRight>
            )}
            <ShopTableContainer>
                <table style={{ width: '100%' }}>
                    <TableHeader>
                        <tr>
                            <BlankColumn />
                            <StyledThTitle>Address</StyledThTitle>
                            <StyledThTitle>Assignment Code</StyledThTitle>
                            <StyledThTitle>
                                {isEditable ? (
                                    <Checkbox
                                        checked={isAllShopsEnabled}
                                        text="Enabled"
                                        id="Enabled"
                                        onChange={handleToggleAllShops}
                                    />
                                ) : (
                                    'Enabled'
                                )}
                            </StyledThTitle>
                        </tr>
                    </TableHeader>
                    <tbody>
                        {shops.map((shop, index) => (
                            <ShopRow
                                // eslint-disable-next-line react/no-array-index-key
                                key={index}
                                index={index}
                                shop={shop}
                                isEditable={isEditable}
                            />
                        ))}
                    </tbody>
                </table>
            </ShopTableContainer>
        </>
    );
};
